import { useMemo } from "react";
import { useBusiness } from "src/hooks/useBusiness";
import { useBusinessBillingInformation } from "src/hooks/useBusinessBillingInfo";

export const useCanUpdateBillingInfo = (businessId?: string) => {
  const { business, loadingBusiness, errorLoadingBusiness } = useBusiness(businessId);

  const {
    billingInfo,
    loading: loadingBillingInfo,
    error: errorLoadingBillingInfo,
  } = useBusinessBillingInformation(businessId);

  const canUpdateBillingInfo = useMemo(() => {
    if (loadingBillingInfo || loadingBusiness) {
      return undefined;
    }

    const isPaperInvoicingCustomer = business ? Boolean(business?.external) : false;
    const isPaypalCustomer = billingInfo ? billingInfo.type === "paypal" : false;

    if (isPaperInvoicingCustomer || isPaypalCustomer) {
      return false;
    }

    return Boolean(billingInfo);
  }, [loadingBillingInfo, loadingBusiness, business, billingInfo]);

  return {
    canUpdateBillingInfo,
    error: errorLoadingBusiness || errorLoadingBillingInfo,
    loading: loadingBusiness,
  };
};
